// eslint-disable-next-line complexity
export function handleGraphQLErrors<
  Base extends { __typename?: string },
  Error extends { __typename?: string; type: string; message: string },
>(data: Base | Error): null | { type: string; message: string } {
  if (
    data.__typename?.includes('ArbeitsbereichNotFound') ||
    data.__typename?.includes('ArbeitszeitNotFound') ||
    data.__typename?.includes('ArbeitszeitUpdateIdArbeitsbereichNull') ||
    data.__typename?.includes('ManagerHasNoAccessToArbeitsbereich') ||
    data.__typename?.includes('ManagerNotFound') ||
    data.__typename?.includes('StandortNotFound') ||
    data.__typename?.includes('UserNotFound') ||
    data.__typename?.includes('ArbeitszeitantragResultArbeitszeitNotFound') ||
    data.__typename?.includes('ArbeitszeitantragResultManagerNotFound') ||
    data.__typename?.includes('ArbeitszeitantragResultOtherValidationError') ||
    data.__typename?.includes('ArbeitszeitantragResultAntragNotFound') ||
    data.__typename?.includes('ArbeitszeitantragResultAlreadyProcessed') ||
    data.__typename?.includes('Error')
  ) {
    const error = data as Error;
    return {
      type: error.type,
      message: error.message,
    };
  }
  const dataAsRecord = data as unknown as Record<string, unknown>;
  const keys = Object.keys(dataAsRecord);
  for (let i = 0; i < keys.length; i++) {
    if (dataAsRecord[keys[i]] instanceof Array) {
      const values = dataAsRecord[keys[i]] as unknown[];
      for (let j = 0; j < values.length; j++) {
        const result = handleGraphQLErrors(values[j] as Base | Error);
        if (result) return result;
      }
    } else if (dataAsRecord[keys[i]] instanceof Object) {
      const result = handleGraphQLErrors(dataAsRecord[keys[i]] as Base | Error);
      if (result) return result;
    }
  }
  return null;
}
